import DefunctSitesView from '../components/defunct-sites/defunct_sites';

$(() => {
    const el = $('.DefunctSite');
    new DefunctSitesView({el, library: window.OverDrive.library, newLibraryName: window.OverDrive.newLibraryName, logoLink: window.OverDrive.logoLink, isMergedSite: window.OverDrive.isMergedSite, isTerminatedSite: window.OverDrive.isTerminatedSite});
});
